import axios, { AxiosRequestConfig } from 'axios';
import type { KnowledgeGraphData } from '../types/api';

const createConfig = (accessToken: string): AxiosRequestConfig => ({
    headers: {
        'Authorization': `Bearer ${accessToken}`,
        'AccessToken': accessToken,
        'Content-Type': 'application/json',
    },
});

export interface KnowledgeGraphQuery {
    /** Périmètre de la portée ; absent ou null = tous les périmètres lisibles (plafonné). */
    perimetreId?: string | null;
    /** Foyers (19/10/2026), dans leur forme `kind:id` ; avec au moins un foyer, le serveur ne dessine que ce qui gravite autour. */
    foyers?: string[];
}

/**
 * Client de `GET /api/graph` (chantier C7) : nœuds et arêtes du graphe
 * notes ↔ entrées, filtrés par ce que l'utilisateur peut lire.
 * Les erreurs remontent à l'appelant (le thunk les traduit en état `failed`).
 */
export const graphService = {
    getKnowledgeGraph: async (query: KnowledgeGraphQuery, accessToken: string): Promise<KnowledgeGraphData> => {
        const params = new URLSearchParams();
        if (query.perimetreId) params.set('perimetreId', query.perimetreId);
        if (query.foyers && query.foyers.length > 0) params.set('foyers', query.foyers.join(','));
        const suffix = params.toString();
        const response = await axios.get(`/api/graph${suffix ? `?${suffix}` : ''}`, createConfig(accessToken));
        return response.data.data;
    },
};

export default graphService;
